import { memo } from 'react';

import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

const AppTextField = memo(function AppTextField({
  label,
  name,
  value,
  onChange,
  onBlur,
  error = false,
  helperText = '',
  required = false,
  disabled = false,
  fullWidth = true,
  type = 'text',
  size = 'small',
  ...rest
}) {
  return (
    <TextField
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      required={required}
      disabled={disabled}
      fullWidth={fullWidth}
      type={type}
      size={size}
      {...rest}
    />
  );
});

AppTextField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.node,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  type: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
};

export default AppTextField;
